// extracted by mini-css-extract-plugin
module.exports = {"module":"GraphPanel_module__2G5f8","header":"GraphPanel_header__3w3w1","graph":"GraphPanel_graph__kCfO9"};